<template>
  <button
    type="button"
    class="auth-submit"
    :class="['auth-submit--' + variant, { 'is-disabled': isInactive }]"
    :disabled="isInactive"
    @click="handleClick">
    <span v-if="loading" class="auth-submit__spinner"></span>
    <span v-else><slot></slot></span>
  </button>
</template>

<script>
  export default {
    name: 'AuthSubmitButton',
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      variant: {
        type: String,
        default: 'primary'
      }
    },
    computed: {
      isInactive() {
        return this.disabled || this.loading;
      }
    },
    methods: {
      handleClick() {
        if (this.isInactive) return;
        this.$emit('click');
      }
    }
  }
</script>

<style scoped>
.auth-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 48px;
  padding: 12px 20px;
  font-size: 0.9375rem;
  font-weight: 600;
  letter-spacing: 0.0125em;
  border: 1px solid transparent;
  border-radius: 12px;
  cursor: pointer;
  transition: opacity .15s ease, transform .15s ease;
}
.auth-submit:active {
  transform: scale(0.995);
}
.auth-submit.is-disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
.auth-submit--primary {
  color: #FFFFFF;
  background: var(--merchant-primary-color, #1AA179);
}
.auth-submit--outline {
  color: var(--merchant-primary-color, #1AA179);
  background: #fff;
  border-color: var(--merchant-primary-color, #1AA179);
}
.auth-submit--ghost {
  color: #6B7886;
  background: transparent;
}
.auth-submit__spinner {
  width: 18px;
  height: 18px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: authSpin .6s linear infinite;
}
@keyframes authSpin {
  to { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/auth/AuthSubmitButton.vue